import { render, staticRenderFns } from "./PembelianInfo.vue?vue&type=template&id=82b32652&"
import script from "./PembelianInfo.vue?vue&type=script&lang=js&"
export * from "./PembelianInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports